const referralSearchMode = {
  Standard: 0,
  Alert: 1,
  Advanced: 2,
  WaitList: 3,
  Basic: 4, //Only Quick search
  Others: 5
};

export default referralSearchMode;
